import { render, staticRenderFns } from "./VulcanIntegration.vue?vue&type=template&id=0122f390&"
import script from "./VulcanIntegration.vue?vue&type=script&lang=js&"
export * from "./VulcanIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports